<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="1">
      <v-row justify="center" v-if="store.orderInfo.type == 'Merchandise'">
        <v-col cols="12" sm="10" md="8" lg="6" xl="6" align="center">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <h3 class="text-center mb-3" translate>
                {{ $t(["ORDER INFORMATION"]) }}
              </h3>

              <v-divider class="mx-3"></v-divider>

              <v-simple-table class="px-3">
                <template v-slot:default>
                  <thead>
                    <tr class="">
                      <th class="text-left" translate>{{ $t(["Name"]) }}</th>
                      <th class="text-left" translate>{{ $t(["Price"]) }}</th>
                      <th class="text-left" translate>{{ $t(["Qty"]) }}</th>
                      <th class="text-left" translate>{{ $t(["Total"]) }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in cart" :key="item.name">
                      <td v-html="$t([replaceHyphen(item.name)])" />
                      <td
                        v-html="
                          $t('Currency', { amount: item.price.toFixed(2) })
                        "
                      />
                      <td>{{ item.quantity }}</td>
                      <td
                        v-html="
                          $t('Currency', { amount: item.total.toFixed(2) })
                        "
                      />
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-divider class="mx-3"></v-divider>

              <!-- <div placeholder="{{ 'TOTAL' | translate }}"></div> -->
              <h2
                v-html="
                  $t(['TOTAL:']) +
                  ' ' +
                  $t('Currency', {
                    amount: store.orderInfo.merchTotal.toFixed(2),
                  })
                "
                class="my-2"
              />

              <v-divider class="mx-3"></v-divider>

              <v-row class="mt-3">
                <v-col cols="12">
                  <v-btn
                    class="btn-text"
                    color="primary"
                    large
                    translate
                    @click="nextStep()"
                  >
                    {{ $t(["Next"]) }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import { useFormDataStore } from "../../../store/formData";

export default {
  name: "S1_OrderInfo",
  data: () => {
    return {};
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  props: {
    cart: Array,
  },
  methods: {
    nextStep() {
      this.$emit("nextStepFromOne");
    },
    replaceHyphen(value) {
      return value.replace("-", "&#8209;");
    },
  },
};
</script>

<style lang="scss" scoped></style>
